import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Flex, Spacing } from "@p0security/ui";
import classNames from "classnames";
import { colors } from "styles/variables";

import { ColorCodeIndicator } from "./ColorCodeIndicator";

type BaseProps = {
  category: string;
  color: string;
  showEye: boolean;
  textColor: string;
  selected?: boolean;
  onClick?: () => void;
};

type PropsWithIcon = {
  count?: never;
  icon: JSX.Element;
} & BaseProps;

type PropsWithCount = {
  count: number;
  icon?: never;
} & BaseProps;

export const FilterStatistic: React.FC<PropsWithCount | PropsWithIcon> = ({
  category,
  color,
  count,
  onClick,
  selected,
  icon,
  showEye: showEye,
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        "flex h-[45px] w-full max-w-[15em] cursor-pointer items-center gap-1 p-1",
        "hover:bg-p0-neutral-20 hover:shadow-[0_2px_4px_var(--color-p0-neutral-10)]",
        "focus:bg-p0-neutral-20 focus:shadow-[0_2px_4px_var(--color-p0-neutral-10)]",
        selected &&
          "bg-[#e6f7ff] shadow-[inset_0_0_2px_var(--color-p0-neutral-30)]"
      )}
    >
      <div className="flex w-full h-full">
        <Flex className="w-[90%] h-full">
          <ColorCodeIndicator color={color} />
          <Flex vertical>
            <div style={{ fontSize: "22px", lineHeight: "22px" }}>
              {count?.toLocaleString()} {icon}
            </div>
            <div style={{ fontSize: "12px" }}>{category}</div>
          </Flex>
        </Flex>
        {showEye && (
          <Spacing asChild mr="6px">
            <div
              style={{
                width: "10%",
                height: "100%",
                color: colors.neutral["30"],
                fontSize: "22px",
              }}
            >
              {selected ? <EyeOutlined /> : <EyeInvisibleOutlined />}
            </div>
          </Spacing>
        )}
      </div>
    </div>
  );
};
